import { createPortal } from "react-dom";
import type { FCWithChildren } from "../@types";
import { MCT_PORTAL_ROOT_ID } from "../config";

/**
 * Wraps a component in a portal if the `renderToPortal`argument is `true`
 * Uses a global root portal element, if it exists, otherwise `document.body`
 */
export const PortalWrapper: FCWithChildren<{ renderToPortal?: boolean }> = ({
  children,
  renderToPortal,
}) => {
  if (!renderToPortal || typeof document === "undefined") {
    return children;
  }

  // Directly querying an element rendered in static HTML above the React root
  // This appears to work consistently, and should avoid any jank involved with
  // using an effect + `useState`
  const portalRoot = document.querySelector<HTMLDivElement>(
    `#${MCT_PORTAL_ROOT_ID}`
  );

  return createPortal(children, portalRoot ?? document.body);
};
